// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wt65","left":"styles_left__1S_KO"};